'use client'

import React from 'react';

import { SpacerBase } from '../../../atoms/GridSystem';
import { useTranslations } from 'next-intl';
// import { useInstantSearch } from 'react-instantsearch'

const AlgoliaNoResultsComponent = () => {
  // const { uiState } = useInstantSearch()
  const t = useTranslations('search')

  return (
    <>
      <SpacerBase xs={3} />
      <p>{t('noResultsLabel')}</p>
    </>
  )
}

export default AlgoliaNoResultsComponent
